import { SquareIcon } from 'styling/GlobalStyles'
import { GlobalViewWidget, GlobalViewWidgetContent, GloblViewWidgetTitle } from '../GlobalView.styled'
import { BodyText } from 'styling/Typography'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { groputDashboardItems } from 'utils/helpers'
import { FileIcon } from 'assets/icons/FileIcon'

export const GLTasksWidget = () => {
    const { taskStatuses } = useSelector((state: RootState) => state.dashboard)
    const getTaskStatus = (name: string): number => {
        return Number(tasksData?.find((td) => td.name == name)?.value) || 0
    }
    const tasksData = groputDashboardItems(taskStatuses)

    return <GlobalViewWidget>
        <GloblViewWidgetTitle>
            <SquareIcon color='#ff9900' >
                {FileIcon}
            </SquareIcon>
            <BodyText weight='bold' >Tasks</BodyText>
        </GloblViewWidgetTitle>
        <GlobalViewWidgetContent>
            <BodyText  >Not started: <span className='bold' >{getTaskStatus('Not Started')}</span></BodyText>
            <BodyText >Completed: <span className='bold' >{getTaskStatus('Completed')}</span></BodyText>
            <BodyText >In Progress: <span className='bold' >{getTaskStatus('In Progress')}</span></BodyText>
            <BodyText  >Idle: <span className='bold' >{getTaskStatus('Idle')}</span></BodyText>
            <BodyText  >Paused: <span className='bold' >{getTaskStatus('Paused')}</span></BodyText>
        </GlobalViewWidgetContent>
    </GlobalViewWidget>
}